var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/function-component-definition */
import { useEffect } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { useNavigate } from 'react-router';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import Button from '@mui/material/Button';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import Logout from '@mui/icons-material/Logout';
import { useTheme } from '@mui/material/styles';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import Typography from '@mui/material/Typography';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { selectEvents, setEvents, setEventsLoading } from '../../store/events';
import { getEventStatus } from '../../types';
import { loadEvents } from '../../api/events';
import { getUniqueId } from '../../utils';
import { PageWrapperNew } from '../../components/atoms/PageWrapper';
import { Delimiter } from '../../components/atoms/Delimiter';
import { removeToken } from '../../api';
import { DataContainerNew } from '../../components/atoms/DataContainer';
import { useErrorHandler } from '../../hooks/useErrorHandler';
const LogoutButton = styled(Button) `
  width: 120px;
`;
export const Events = () => {
    const nav = useNavigate();
    const theme = useTheme();
    const dispatch = useAppDispatch();
    const events = useAppSelector(selectEvents);
    const { errorHandler } = useErrorHandler();
    const logOut = () => {
        removeToken();
        nav('/login');
    };
    const getEvents = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        try {
            dispatch(setEventsLoading(true));
            const result = yield loadEvents();
            // console.log('Events getEvents', result)
            dispatch(setEvents(result));
        }
        catch (e) {
            if (((_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
                logOut();
                return;
            }
            errorHandler(e);
        }
        finally {
            dispatch(setEventsLoading(false));
        }
    });
    useEffect(() => {
        getEvents();
    }, []);
    // console.log('Events events', events)
    const onClick = (eventId) => {
        // dispatch(setEventId(eventId))
        nav(`/matches?eventId=${eventId}`);
    };
    const StyledTableCell = styled(TableCell) `
    width: 120px;
  `;
    return (_jsx(DataContainerNew, { children: _jsxs(PageWrapperNew, { children: [_jsx(Button, Object.assign({ sx: { width: 120 }, startIcon: _jsx(Logout, {}), onClick: logOut }, { children: "\u0412\u044B\u0445\u043E\u0434" })), _jsx(Delimiter, { top: "49px" }), _jsx(Typography, Object.assign({ sx: { alignSelf: 'center' }, variant: "h2" }, { children: "\u0410\u0444\u0438\u0448\u0430" })), _jsx(Delimiter, { top: "30px" }), _jsx(TableContainer, Object.assign({ sx: { maxWidth: 700, alignSelf: 'center' }, component: Paper }, { children: _jsxs(Table, Object.assign({ "aria-label": "customized table" }, { children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u0414\u0430\u0442\u0430" })), _jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435" })), _jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u0421\u0442\u0430\u0442\u0443\u0441" })), _jsx(TableCell, Object.assign({ variant: "head", align: "center" }, { children: "\u0418\u0433\u0440\u043E\u043A\u043E\u0432" }))] }) }), _jsx(TableBody, { children: events === null || events === void 0 ? void 0 : events.map((event) => (_jsxs(TableRow, Object.assign({ hover: true, onClick: () => onClick(event.id) }, { children: [_jsx(TableCell, Object.assign({ variant: "body", id: getUniqueId(event.id), align: "center" }, { children: moment(event.date, 'DD.MM.YYYY').format('DD.MM.YYYY') })), _jsx(TableCell, Object.assign({ variant: "body", align: "center" }, { children: event.name })), _jsx(TableCell, Object.assign({ variant: "body", align: "center" }, { children: getEventStatus(event.status) })), _jsx(TableCell, Object.assign({ variant: "body", align: "center" }, { children: event.playerCount }))] }), event.id))) })] })) }))] }) }));
};
